import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GotoDialogComponent } from './goto-dialog.component';



@NgModule({
  declarations: [
    GotoDialogComponent
  ],
  exports: [
    GotoDialogComponent
  ],
  imports: [
    CommonModule
  ]
})
export class GotoDialogModule { }
